import { FC } from 'react';
import style from './ContainerWrapper.module.scss';

export interface ContainerWrapperProps {}
export const ContainerWrapper: FC<ContainerWrapperProps> = ({ children }) => {
  return <div className={style.container}>{children}</div>;
};
